// Barcode scanners type like a keyboard; keep touch/virtual keyboards and browser text helpers from rewriting the code.
export const scannerInputAttributes = {
  autoComplete: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
} as const;
